import React, { useState, useEffect, useRef } from 'react';
import { apiRequest } from '../../api';
import NotificationCard from './NotificationCard';
import NotificationInfoPanel from './NotificationInfoPanel';
import Pagination from '../Pagination';

const ModerationList = ({ selectedNotification, setSelectedNotification, closeInfoPanel, isOpen, userId }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [statusFilter, setStatusFilter] = useState('all');
  const [total, setTotal] = useState(0);
  const [itemsLimit, setItemsLimit] = useState(20);
  const [offset, setOffset] = useState(0);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const intervalRef = useRef(null);
  const notificationsRef = useRef([]);

  useEffect(() => {
    notificationsRef.current = notifications;
  }, [notifications]);

  const loadNotifications = async () => {
    try {
      if (isInitialLoad) {
        setLoading(true);
      }
      setError(null);

      let url = `/approve/${userId}/list?limit=${itemsLimit}&offset=${offset}`;
      if (statusFilter !== 'all') {
        url += `&status=${statusFilter}`;
      }

      const response = await apiRequest(url, 'GET');
      console.log("response: ", response);

      const newNotifications = response.data.items || [];
      const newTotal = response.data.total || 0;

      setTotal(newTotal);

      const areNotificationsEqual = notificationsRef.current.length === newNotifications.length &&
        notificationsRef.current.every((notif, index) => notif.id === newNotifications[index].id &&
          notif.created_at === newNotifications[index].created_at);

      if (!areNotificationsEqual) {
        setNotifications(newNotifications);
      }

      if (isInitialLoad) {
        setIsInitialLoad(false);
      }
    } catch (err) {
      console.error('Ошибка при загрузке уведомлений:', err);
      setError('Не удалось загрузить уведомления');
    } finally {
      if (isInitialLoad) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (isOpen && userId) {
      setIsInitialLoad(true);
      loadNotifications();
    }
  }, [statusFilter, itemsLimit, offset, isOpen, userId]);

  useEffect(() => {
    if (isOpen && userId && !isInitialLoad) {
      intervalRef.current = setInterval(() => {
        loadNotifications();
      }, 10000);

      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }
  }, [isOpen, userId, isInitialLoad]);

  const handleNotificationClick = (notification) => {
    setSelectedNotification(notification);
  };

  const handleBodyClick = (e) => {
    const panel = e.currentTarget.querySelector('.notification-details-panel.open');
    if (panel && !panel.contains(e.target)) {
      closeInfoPanel();
    }
  };

  const handleDetailsPanelClick = (e) => {
    closeInfoPanel();
  };

  const handlePageChange = (newPage) => {
    setOffset((newPage - 1) * itemsLimit);
  };

  const handleLimitChange = (newLimit) => {
    setItemsLimit(newLimit);
    setOffset(0);
  };

  const currentPage = Math.floor(offset / itemsLimit) + 1;

  return (
      <>
      <div className="modal-body" onClick={handleBodyClick}>
        <div className="notifications-container">
          <div className="notifications-filters">
            <button
              className={`filter-btn ${statusFilter === 'all' ? 'active' : ''}`}
              onClick={(e) => {
                closeInfoPanel();
                setStatusFilter('all');
              }}
            >
              Все
            </button>
            <button
              className={`filter-btn ${statusFilter === 'wait' ? 'active' : ''}`}
              onClick={(e) => {
                closeInfoPanel();
                setStatusFilter('wait');
              }}
            >
              Ожидают
            </button>
            <button
              className={`filter-btn ${statusFilter === 'success' ? 'active' : ''}`}
              onClick={(e) => {
                closeInfoPanel();
                setStatusFilter('success');
              }}
            >
              Одобрено
            </button>
            <button
              className={`filter-btn ${statusFilter === 'reject' ? 'active' : ''}`}
              onClick={(e) => {
                closeInfoPanel();
                setStatusFilter('reject');
              }}
            >
              Отклонено
            </button>
          </div>

          {loading ? (
            <div className="loading">Загрузка уведомлений...</div>
          ) : notifications.length === 0 ? (
            <div className="no-notifications">Нет уведомлений</div>
          ) : error ? (
            <div className="error">{error}</div>
          ) : (
            <div className="notifications-list">
              {notifications.map((notification) => (
                <NotificationCard
                  key={notification.id}
                  notification={notification}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleNotificationClick(notification);
                  }}
                />
              ))}
            </div>
          )}

        <div
          className={`notification-details-panel ${selectedNotification ? 'open' : ''}`}
          onClick={handleDetailsPanelClick}
        >
          {selectedNotification && (
            <NotificationInfoPanel
              notification={selectedNotification}
              onClose={closeInfoPanel}
            />
          )}
        </div>
      </div>
    </div>
      <div className="modal-footer">
        <Pagination
          currentPage={currentPage}
          total={total}
          limit={itemsLimit}
          onPageChange={handlePageChange}
          onLimitChange={handleLimitChange}
        />
      </div>
    </>
  );
};

export default ModerationList;
